import { API, ApiPrefixes } from "../api";

export const adminLoanRepaymentApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getUpcomingRepayment: builder.query({
      query: (page) => ({
        url:
          ApiPrefixes["loanManagement"] +
          `/repayments/upcoming?guard=staff&page=${page}&limit=20`,
      }),
      providesTags: (result, error, arg) => [
        { type: "upcoming-loan-repayment", id: arg },
      ],
      cacheStrategy: "cache-and-network",
    }),
    getDueRepayment: builder.query({
      query: (page) => ({
        url:
          ApiPrefixes["loanManagement"] +
          `/repayments/due?guard=staff&page=${page}&limit=20`,
      }),
      providesTags: (result, error, arg) => [
        { type: "due-loan-repayment", id: arg },
      ],
      cacheStrategy: "cache-and-network",
    }),
    getOverdueRepayment: builder.query({
      query: (page) => ({
        url:
          ApiPrefixes["loanManagement"] +
          `/repayments/overdue?guard=staff&page=${page}&limit=20`,
      }),
      providesTags: (result, error, arg) => [
        { type: "overdue-loan-repayment", id: arg },
      ],
      cacheStrategy: "cache-and-network",
    }),

    recordLoanRepayment: builder.mutation({
      query: (payload) => ({
        url: ApiPrefixes["loanManagement"] + `/requests/payment?guard=staff`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: [
        { type: "upcoming-loan-repayment" },
        { type: "due-loan-repayment" },
        { type: "overdue-loan-repayment" },
        { type: "loan-request-breakdown-by-id" },
        "StaffDashboard",
      ],
    }),

    waiveLoanLateFee: builder.mutation({
      query: ({ feeId, reason }) => ({
        url: ApiPrefixes["loanManagement"] + `/requests/late-fees/${feeId}/waive?guard=staff`,
        method: "POST",
        body: { reason },
      }),
      invalidatesTags: [
        { type: "loan-request-breakdown-by-id" },
        { type: "loan-request-details" },
        { type: "member-loan-summary" },
      ],
    }),

    recordInformalLoanPayment: builder.mutation({
      query: (payload) => ({
        url: ApiPrefixes["loanManagement"] + `/requests/payment-informal?guard=staff`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: [
        { type: "upcoming-loan-repayment" },
        { type: "due-loan-repayment" },
        { type: "overdue-loan-repayment" },
        { type: "loan-request-breakdown-by-id" },
        { type: "loan-request-details" },
        { type: "disbursed-loans-list" },
        { type: "paid-loans-list" },
        { type: "member-loan-summary" },
        { type: "member-upcoming-repayment-list" },
        { type: "member-due-repayment-list" },
        { type: "member-overdue-repayment-list" },
        { type: "member-disbursed-loans-list" },
        "StaffDashboard",
      ],
    }),
    searchLoanByMember: builder.query({
      query: (search) => ({
        url:
          ApiPrefixes["loanManagement"] +
          `/requests/member?guard=staff&search=${search}`,
      }),

      transformResponse: (responseData) => {
        return responseData.data;
      },
    }),

    getLoanBreakdownByLoanRequestId: builder.query({
      query: (requestId) => ({
        url:
          ApiPrefixes["loanManagement"] +
          `/requests/${requestId}/view?guard=staff`,
      }),

      transformResponse: (responseData) => {
        return responseData.data;
      },
      providesTags: (result, error, arg) => [
        { type: "loan-request-breakdown-by-id", id: arg },
        { type: "loan-request-details", id: arg },
      ],
    }),

    applyInformalInterest: builder.mutation({
      query: (requestId) => ({
        url:
          ApiPrefixes["loanManagement"] +
          `/requests/${requestId}/apply-informal-interest?guard=staff`,
        method: "POST",
      }),
      invalidatesTags: [
        { type: "loan-request-breakdown-by-id" },
        { type: "loan-request-details" },
        { type: "member-loan-summary" },
        { type: "member-disbursed-loans-list" },
      ],
    }),
  }),
});

export const {
  useGetDueRepaymentQuery,
  useGetOverdueRepaymentQuery,
  useGetUpcomingRepaymentQuery,
  useRecordLoanRepaymentMutation,
  useRecordInformalLoanPaymentMutation,
  useWaiveLoanLateFeeMutation,
  useSearchLoanByMemberQuery,
  useLazySearchLoanByMemberQuery,
  useGetLoanBreakdownByLoanRequestIdQuery,
  useApplyInformalInterestMutation,
} = adminLoanRepaymentApi;
